/**
 * LaunchDarkly gate for the plugin-templates surface — the Templates tab in
 * the marketplace and the instantiation wizard route. LD key:
 * `om_tech_21417_plugin_templates`; the React SDK camelCases flag keys, so
 * call sites read the camelCase form.
 *
 * The backend evaluates the same flag against a **user**-kind context (the
 * caller's user id), not a merchant/vendor context, because it covers admin
 * template authoring today and vendor/merchant instantiation next. Portal's
 * LD context is the signed-in user, so the two agree.
 *
 * Default OFF: every environment resolves to off until targeting flips it,
 * and integration-service 404s the template endpoints while it is off.
 */
export const PLUGIN_TEMPLATES_FLAG = 'omTech21417PluginTemplates';
export const PLUGIN_TEMPLATES_FLAG_DEFAULT = false;
